import { styled } from '@mui/material/styles';
import WdPageSimple from '@main/core/WdPageSimple/WdPageSimple';
import { useContext, useEffect, useState } from 'react';
import { ComposedHeader, FormCardLayout, TextWithLabel } from '@main/components';
import { useRequest } from '@main/hooks';
import { useSearchParams } from 'react-router-dom';
import { Box, Chip, Divider, Grid, Typography } from '@mui/material';
import { getTorniquetById } from 'src/app/api/torniquet';
import { formatDate } from 'src/app/utils/dates';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/core/messageSlice';
import { BootstrapContext } from 'app/bootstrap/BootstrapContext';

const Root = styled(WdPageSimple)(({ theme }) => ({
  backgroundColor: '#FFF',
  '& .WdPageSimple-header': {},
  '& .WdPageSimple-content': {},
}));

const Info = () => {
  const [searchParams] = useSearchParams();
  const previousId = searchParams.get('id');
  const [data, setData] = useState({});

  const Dispatch = useDispatch();

  const { finalizeSession } = useContext(BootstrapContext);
  const handleOnForbidden = async () => {
    await finalizeSession();
  };

  const handleOnError = async (message) => {
    Dispatch(showMessage({ message }));
  };
  const {
    makeRequest: trygetTorniquetByID,
    response: responseGetCompany,
    isLoading: isLoadingGetCompany,
  } = useRequest(getTorniquetById, {
    onForbidden: handleOnForbidden,
    onError: handleOnError,
  });

  useEffect(() => {
    if (previousId === undefined) return;
    trygetTorniquetByID(previousId);
    console.log('Id facturacion: ', previousId);
  }, [previousId]);

  useEffect(() => {
    if (responseGetCompany === undefined) return;
    setData(responseGetCompany);
    console.log('Contenido de la respuesta', responseGetCompany);
  }, [responseGetCompany]);

  const test = 'test 01';

  return (
    <Root
      header={
        <ComposedHeader
          decorator="button"
          title="Información de Torniquete"
          description="Información general de dispositivo de Torniquete"
        />
      }
      content={
        <Box
          className="flex justify-center items-start"
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <FormCardLayout maxWidth="120rem">
            <Grid container spacing={2} className="mx-32">
              <Grid item xs={12} md={5}>
                <Box sx={{ flex: 1 }}>
                  <div className="my-16">
                    <Typography className="text-2xl font-light">Información de termnal</Typography>
                  </div>
                  {data?.id && <TextWithLabel title="ID terminal">{data?.id}</TextWithLabel>}
                  {data?.key && <TextWithLabel title="Clave">{data?.key}</TextWithLabel>}
                  {data?.name && <TextWithLabel title="Nombre">{data?.name}</TextWithLabel>}
                  {data?.description && (
                    <TextWithLabel title="Descripción">{data?.description}</TextWithLabel>
                  )}
                  {data?.deviceId && (
                    <TextWithLabel title="ID Dispositivo">{data?.deviceId}</TextWithLabel>
                  )}
                  {data?.modelName && (
                    <TextWithLabel title="Modelo">{data?.modelName}</TextWithLabel>
                  )}
                  {data?.hostname && (
                    <TextWithLabel title="Hostname">{data?.hostname}</TextWithLabel>
                  )}
                  {data?.terminalType && (
                    <TextWithLabel title="Tipo de terminal">{data?.terminalType}</TextWithLabel>
                  )}
                  {data?.accessType && (
                    <TextWithLabel title="Tipo de acceso">{data?.accessType}</TextWithLabel>
                  )}
                  {data?.status && (
                    <>
                      <TextWithLabel title="Estatus" />
                      <Chip
                        color={data?.status ? 'success' : 'error'}
                        variant="outlined"
                        label={data?.status ? 'Activo' : 'Inactivo'}
                      />
                    </>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} md={1} className="flex justify-center items-center">
                <Divider orientation="vertical" flexItem />
              </Grid>

              <Grid item xs={12} md={6}>
                {data?.locationName && (
                  <TextWithLabel title="Calle">{data?.locationName ?? 'Locación'}</TextWithLabel>
                )}
                {data?.companyName && (
                  <TextWithLabel title="Compañía">{data?.companyName}</TextWithLabel>
                )}
                {data?.locationName && (
                  <TextWithLabel title="Locación">{data?.locationName}</TextWithLabel>
                )}
                {data?.buildingName && (
                  <TextWithLabel title="Edificio">{data?.buildingName}</TextWithLabel>
                )}
                {data?.zoneName && <TextWithLabel title="Zona">{data?.zoneName}</TextWithLabel>}
                {data?.updated_at && (
                  <TextWithLabel title="Fecha de Actualización">
                    {formatDate(data?.updated_at)}
                  </TextWithLabel>
                )}
                {data?.created_at && (
                  <TextWithLabel title="Fecha de Creación">
                    {formatDate(data?.created_at)}
                  </TextWithLabel>
                )}
              </Grid>
            </Grid>
          </FormCardLayout>
        </Box>
      }
    />
  );
};

export default Info;

